import styled from "styled-components";
import { motion } from "framer-motion";

/* ---------- OVERLAY ---------- */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(10px);
  z-index: 999;
`;

/* ---------- CARD ---------- */
const Card = styled(motion.div)`
  position: fixed;
  inset: 0;
  margin: auto;
  height: 300px;
  width: 480px;
  max-width: calc(100% - 32px);

  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.9),
    rgba(15, 23, 42, 0.75)
  );

  backdrop-filter: blur(28px);
  border: 1px solid rgba(99, 102, 241, 0.35);
  border-radius: 22px;
  padding: 28px;

  color: #e5e7eb;
  z-index: 1000;

  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.55),
    inset 0 0 0 1px rgba(255, 255, 255, 0.03);
`;

/* ---------- TEXT ---------- */
const Title = styled.div`
  font-weight: 800;
  font-size: 20px;
  margin-bottom: 10px;
  letter-spacing: 0.2px;
`;

const Text = styled.div`
  font-size: 15px;
  opacity: 0.9;
  line-height: 1.7;
  margin-bottom: 6px;

  strong {
    color: #a5b4fc;
    font-weight: 700;
  }
`;

/* ---------- ACTIONS ---------- */
const Actions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 22px;
  flex-wrap: wrap;
`;

const Btn = styled.button`
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  font-size: 14px;
  cursor: pointer;
  font-weight: 700;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:active {
    transform: scale(0.97);
  }
`;

const Primary = styled(Btn)`
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  color: white;
  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.45);
`;

const Ghost = styled(Btn)`
  background: rgba(255, 255, 255, 0.08);
  color: #c7d2fe;
`;

/* ---------- COMPONENT ---------- */
export default function MotivationModal({
  day,
  tech,
  onContinue,
  onMentor,
  onClose,
}) {
  return (
    <>
      <Overlay onClick={onClose} />

      <Card
        initial={{ opacity: 0, scale: 0.95, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 220, damping: 20 }}
      >
        <Title>👋 Hey, just checking in</Title>

        <Text>
          You’re on <strong>Day {day}</strong> of your <strong>{tech}</strong>{" "}
          roadmap.
          <br />
          <br />
          You don’t need a perfect day.
          <br />
          <strong>20–30 minutes is enough.</strong>
          Just keep the chain alive.
        </Text>

        <Actions>
          <Primary onClick={onContinue}>Continue Day {day}</Primary>

          <Ghost onClick={onMentor}>Ask AI Mentor</Ghost>

          <Ghost onClick={onClose}>Not now</Ghost>
        </Actions>
      </Card>
    </>
  );
}
